/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type McpAuthorizationServerMetadataResponse,
    McpAuthorizationServerMetadataResponseFromJSON,
    McpAuthorizationServerMetadataResponseToJSON,
} from '../models/McpAuthorizationServerMetadataResponse';
import {
    type McpConsentApprovalRequest,
    McpConsentApprovalRequestFromJSON,
    McpConsentApprovalRequestToJSON,
} from '../models/McpConsentApprovalRequest';
import {
    type McpConsentDetailResponse,
    McpConsentDetailResponseFromJSON,
    McpConsentDetailResponseToJSON,
} from '../models/McpConsentDetailResponse';
import {
    type McpConsentRedirectResponse,
    McpConsentRedirectResponseFromJSON,
    McpConsentRedirectResponseToJSON,
} from '../models/McpConsentRedirectResponse';
import {
    type McpGrantResponse,
    McpGrantResponseFromJSON,
    McpGrantResponseToJSON,
} from '../models/McpGrantResponse';
import {
    type McpOAuthErrorResponse,
    McpOAuthErrorResponseFromJSON,
    McpOAuthErrorResponseToJSON,
} from '../models/McpOAuthErrorResponse';
import {
    type McpOAuthTokenResponse,
    McpOAuthTokenResponseFromJSON,
    McpOAuthTokenResponseToJSON,
} from '../models/McpOAuthTokenResponse';
import {
    type McpProtectedResourceMetadataResponse,
    McpProtectedResourceMetadataResponseFromJSON,
    McpProtectedResourceMetadataResponseToJSON,
} from '../models/McpProtectedResourceMetadataResponse';

export interface ApproveMCPAuthorizationRequestRequest {
    handle: string;
    mcpConsentApprovalRequest: McpConsentApprovalRequest;
}

export interface DenyMCPAuthorizationRequestRequest {
    handle: string;
    body: object;
}

export interface ListProjectMCPGrantsRequest {
    projectId: string;
}

export interface MCPAuthorizationRequestDetailRequest {
    handle: string;
}

export interface MCPOAuthAuthorizationRequest {
    responseType: MCPOAuthAuthorizationResponseTypeEnum;
    clientId: string;
    redirectUri: string;
    state: string;
    resource: string;
    scope: MCPOAuthAuthorizationScopeEnum;
    codeChallenge: string;
    codeChallengeMethod: MCPOAuthAuthorizationCodeChallengeMethodEnum;
}

export interface MCPOAuthRevocationRequest {
    token: string;
    clientId: string;
    tokenTypeHint?: MCPOAuthRevocationTokenTypeHintEnum;
}

export interface MCPOAuthTokenRequest {
    grantType?: MCPOAuthTokenGrantTypeEnum;
    clientId?: string;
    code?: string;
    redirectUri?: string;
    codeVerifier?: string;
    resource?: string;
    refreshToken?: string;
}

export interface RevokeProjectMCPGrantRequest {
    projectId: string;
    grantId: string;
}

/**
 * 
 */
export class MCPOAuthApi extends runtime.BaseAPI {

    /**
     * Creates request options for approveMCPAuthorizationRequest without sending the request
     */
    async approveMCPAuthorizationRequestRequestOpts(requestParameters: ApproveMCPAuthorizationRequestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['handle'] == null) {
            throw new runtime.RequiredError(
                'handle',
                'Required parameter "handle" was null or undefined when calling approveMCPAuthorizationRequest().'
            );
        }

        if (requestParameters['mcpConsentApprovalRequest'] == null) {
            throw new runtime.RequiredError(
                'mcpConsentApprovalRequest',
                'Required parameter "mcpConsentApprovalRequest" was null or undefined when calling approveMCPAuthorizationRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/mcp/authorization-requests/{handle}/approve`;
        urlPath = urlPath.replace('{handle}', encodeURIComponent(String(requestParameters['handle'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: McpConsentApprovalRequestToJSON(requestParameters['mcpConsentApprovalRequest']),
        };
    }

    /**
     */
    async approveMCPAuthorizationRequestRaw(requestParameters: ApproveMCPAuthorizationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<McpConsentRedirectResponse>> {
        const requestOptions = await this.approveMCPAuthorizationRequestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => McpConsentRedirectResponseFromJSON(jsonValue));
    }

    /**
     */
    async approveMCPAuthorizationRequest(requestParameters: ApproveMCPAuthorizationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<McpConsentRedirectResponse> {
        const response = await this.approveMCPAuthorizationRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for denyMCPAuthorizationRequest without sending the request
     */
    async denyMCPAuthorizationRequestRequestOpts(requestParameters: DenyMCPAuthorizationRequestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['handle'] == null) {
            throw new runtime.RequiredError(
                'handle',
                'Required parameter "handle" was null or undefined when calling denyMCPAuthorizationRequest().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling denyMCPAuthorizationRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/mcp/authorization-requests/{handle}/deny`;
        urlPath = urlPath.replace('{handle}', encodeURIComponent(String(requestParameters['handle'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     */
    async denyMCPAuthorizationRequestRaw(requestParameters: DenyMCPAuthorizationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<McpConsentRedirectResponse>> {
        const requestOptions = await this.denyMCPAuthorizationRequestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => McpConsentRedirectResponseFromJSON(jsonValue));
    }

    /**
     */
    async denyMCPAuthorizationRequest(requestParameters: DenyMCPAuthorizationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<McpConsentRedirectResponse> {
        const response = await this.denyMCPAuthorizationRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listProjectMCPGrants without sending the request
     */
    async listProjectMCPGrantsRequestOpts(requestParameters: ListProjectMCPGrantsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling listProjectMCPGrants().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/mcp/grants`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async listProjectMCPGrantsRaw(requestParameters: ListProjectMCPGrantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<McpGrantResponse>>> {
        const requestOptions = await this.listProjectMCPGrantsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(McpGrantResponseFromJSON));
    }

    /**
     */
    async listProjectMCPGrants(requestParameters: ListProjectMCPGrantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<McpGrantResponse>> {
        const response = await this.listProjectMCPGrantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mCPAuthorizationRequestDetail without sending the request
     */
    async mCPAuthorizationRequestDetailRequestOpts(requestParameters: MCPAuthorizationRequestDetailRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['handle'] == null) {
            throw new runtime.RequiredError(
                'handle',
                'Required parameter "handle" was null or undefined when calling mCPAuthorizationRequestDetail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/mcp/authorization-requests/{handle}`;
        urlPath = urlPath.replace('{handle}', encodeURIComponent(String(requestParameters['handle'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async mCPAuthorizationRequestDetailRaw(requestParameters: MCPAuthorizationRequestDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<McpConsentDetailResponse>> {
        const requestOptions = await this.mCPAuthorizationRequestDetailRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => McpConsentDetailResponseFromJSON(jsonValue));
    }

    /**
     */
    async mCPAuthorizationRequestDetail(requestParameters: MCPAuthorizationRequestDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<McpConsentDetailResponse> {
        const response = await this.mCPAuthorizationRequestDetailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mCPOAuthAuthorization without sending the request
     */
    async mCPOAuthAuthorizationRequestOpts(requestParameters: MCPOAuthAuthorizationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['responseType'] == null) {
            throw new runtime.RequiredError(
                'responseType',
                'Required parameter "responseType" was null or undefined when calling mCPOAuthAuthorization().'
            );
        }

        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling mCPOAuthAuthorization().'
            );
        }

        if (requestParameters['redirectUri'] == null) {
            throw new runtime.RequiredError(
                'redirectUri',
                'Required parameter "redirectUri" was null or undefined when calling mCPOAuthAuthorization().'
            );
        }

        if (requestParameters['state'] == null) {
            throw new runtime.RequiredError(
                'state',
                'Required parameter "state" was null or undefined when calling mCPOAuthAuthorization().'
            );
        }

        if (requestParameters['resource'] == null) {
            throw new runtime.RequiredError(
                'resource',
                'Required parameter "resource" was null or undefined when calling mCPOAuthAuthorization().'
            );
        }

        if (requestParameters['scope'] == null) {
            throw new runtime.RequiredError(
                'scope',
                'Required parameter "scope" was null or undefined when calling mCPOAuthAuthorization().'
            );
        }

        if (requestParameters['codeChallenge'] == null) {
            throw new runtime.RequiredError(
                'codeChallenge',
                'Required parameter "codeChallenge" was null or undefined when calling mCPOAuthAuthorization().'
            );
        }

        if (requestParameters['codeChallengeMethod'] == null) {
            throw new runtime.RequiredError(
                'codeChallengeMethod',
                'Required parameter "codeChallengeMethod" was null or undefined when calling mCPOAuthAuthorization().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['responseType'] != null) {
            queryParameters['response_type'] = requestParameters['responseType'];
        }

        if (requestParameters['clientId'] != null) {
            queryParameters['client_id'] = requestParameters['clientId'];
        }

        if (requestParameters['redirectUri'] != null) {
            queryParameters['redirect_uri'] = requestParameters['redirectUri'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        if (requestParameters['resource'] != null) {
            queryParameters['resource'] = requestParameters['resource'];
        }

        if (requestParameters['scope'] != null) {
            queryParameters['scope'] = requestParameters['scope'];
        }

        if (requestParameters['codeChallenge'] != null) {
            queryParameters['code_challenge'] = requestParameters['codeChallenge'];
        }

        if (requestParameters['codeChallengeMethod'] != null) {
            queryParameters['code_challenge_method'] = requestParameters['codeChallengeMethod'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/oauth/authorize`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async mCPOAuthAuthorizationRaw(requestParameters: MCPOAuthAuthorizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.mCPOAuthAuthorizationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async mCPOAuthAuthorization(requestParameters: MCPOAuthAuthorizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.mCPOAuthAuthorizationRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for mCPOAuthAuthorizationServerMetadata without sending the request
     */
    async mCPOAuthAuthorizationServerMetadataRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/.well-known/oauth-authorization-server`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async mCPOAuthAuthorizationServerMetadataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<McpAuthorizationServerMetadataResponse>> {
        const requestOptions = await this.mCPOAuthAuthorizationServerMetadataRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => McpAuthorizationServerMetadataResponseFromJSON(jsonValue));
    }

    /**
     */
    async mCPOAuthAuthorizationServerMetadata(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<McpAuthorizationServerMetadataResponse> {
        const response = await this.mCPOAuthAuthorizationServerMetadataRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mCPOAuthRevocation without sending the request
     */
    async mCPOAuthRevocationRequestOpts(requestParameters: MCPOAuthRevocationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling mCPOAuthRevocation().'
            );
        }

        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling mCPOAuthRevocation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['token'] != null) {
            formParams.append('token', requestParameters['token'] as any);
        }

        if (requestParameters['clientId'] != null) {
            formParams.append('client_id', requestParameters['clientId'] as any);
        }

        if (requestParameters['tokenTypeHint'] != null) {
            formParams.append('token_type_hint', requestParameters['tokenTypeHint'] as any);
        }


        let urlPath = `/oauth/revoke`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
    }

    /**
     */
    async mCPOAuthRevocationRaw(requestParameters: MCPOAuthRevocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<any>>> {
        const requestOptions = await this.mCPOAuthRevocationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async mCPOAuthRevocation(requestParameters: MCPOAuthRevocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<any>> {
        const response = await this.mCPOAuthRevocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mCPOAuthToken without sending the request
     */
    async mCPOAuthTokenRequestOpts(requestParameters: MCPOAuthTokenRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['grantType'] != null) {
            formParams.append('grant_type', requestParameters['grantType'] as any);
        }

        if (requestParameters['clientId'] != null) {
            formParams.append('client_id', requestParameters['clientId'] as any);
        }

        if (requestParameters['code'] != null) {
            formParams.append('code', requestParameters['code'] as any);
        }

        if (requestParameters['redirectUri'] != null) {
            formParams.append('redirect_uri', requestParameters['redirectUri'] as any);
        }

        if (requestParameters['codeVerifier'] != null) {
            formParams.append('code_verifier', requestParameters['codeVerifier'] as any);
        }

        if (requestParameters['resource'] != null) {
            formParams.append('resource', requestParameters['resource'] as any);
        }

        if (requestParameters['refreshToken'] != null) {
            formParams.append('refresh_token', requestParameters['refreshToken'] as any);
        }


        let urlPath = `/oauth/token`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
    }

    /**
     */
    async mCPOAuthTokenRaw(requestParameters: MCPOAuthTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<McpOAuthTokenResponse>> {
        const requestOptions = await this.mCPOAuthTokenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => McpOAuthTokenResponseFromJSON(jsonValue));
    }

    /**
     */
    async mCPOAuthToken(requestParameters: MCPOAuthTokenRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<McpOAuthTokenResponse> {
        const response = await this.mCPOAuthTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mCPProtectedResourceMetadata without sending the request
     */
    async mCPProtectedResourceMetadataRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/.well-known/oauth-protected-resource/mcp`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async mCPProtectedResourceMetadataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<McpProtectedResourceMetadataResponse>> {
        const requestOptions = await this.mCPProtectedResourceMetadataRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => McpProtectedResourceMetadataResponseFromJSON(jsonValue));
    }

    /**
     */
    async mCPProtectedResourceMetadata(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<McpProtectedResourceMetadataResponse> {
        const response = await this.mCPProtectedResourceMetadataRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for revokeProjectMCPGrant without sending the request
     */
    async revokeProjectMCPGrantRequestOpts(requestParameters: RevokeProjectMCPGrantRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling revokeProjectMCPGrant().'
            );
        }

        if (requestParameters['grantId'] == null) {
            throw new runtime.RequiredError(
                'grantId',
                'Required parameter "grantId" was null or undefined when calling revokeProjectMCPGrant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/mcp/grants/{grantId}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{grantId}', encodeURIComponent(String(requestParameters['grantId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async revokeProjectMCPGrantRaw(requestParameters: RevokeProjectMCPGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.revokeProjectMCPGrantRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async revokeProjectMCPGrant(requestParameters: RevokeProjectMCPGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.revokeProjectMCPGrantRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const MCPOAuthAuthorizationResponseTypeEnum = {
    Code: 'code'
} as const;
export type MCPOAuthAuthorizationResponseTypeEnum = typeof MCPOAuthAuthorizationResponseTypeEnum[keyof typeof MCPOAuthAuthorizationResponseTypeEnum];
/**
 * @export
 */
export const MCPOAuthAuthorizationScopeEnum = {
    McpRead: 'mcp:read'
} as const;
export type MCPOAuthAuthorizationScopeEnum = typeof MCPOAuthAuthorizationScopeEnum[keyof typeof MCPOAuthAuthorizationScopeEnum];
/**
 * @export
 */
export const MCPOAuthAuthorizationCodeChallengeMethodEnum = {
    S256: 'S256'
} as const;
export type MCPOAuthAuthorizationCodeChallengeMethodEnum = typeof MCPOAuthAuthorizationCodeChallengeMethodEnum[keyof typeof MCPOAuthAuthorizationCodeChallengeMethodEnum];
/**
 * @export
 */
export const MCPOAuthRevocationTokenTypeHintEnum = {
    AccessToken: 'access_token',
    RefreshToken: 'refresh_token'
} as const;
export type MCPOAuthRevocationTokenTypeHintEnum = typeof MCPOAuthRevocationTokenTypeHintEnum[keyof typeof MCPOAuthRevocationTokenTypeHintEnum];
/**
 * @export
 */
export const MCPOAuthTokenGrantTypeEnum = {
    RefreshToken: 'refresh_token'
} as const;
export type MCPOAuthTokenGrantTypeEnum = typeof MCPOAuthTokenGrantTypeEnum[keyof typeof MCPOAuthTokenGrantTypeEnum];
